var _style, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "video_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M736.9 512.3L948.5 732V292L736.9 511.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M736.6 512l.3.3v-.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF17",
    d: "M948.5 227c-17.3 0-34.3 6.9-46.8 19.9L736.9 418l-47.1 48.9a65.162 65.162 0 00-17.9 38.7c-.4 4.2-.4 8.5 0 12.7 1.4 14.1 7.3 27.8 17.9 38.7l47.1 48.9 164.8 171c12.5 13 29.5 19.9 46.8 19.9 8.2 0 16.4-1.5 24.3-4.7 24.6-9.9 40.7-33.8 40.7-60.3V292c0-26.5-16.1-50.4-40.7-60.3-7.9-3.1-16.1-4.7-24.3-4.7zm0 505L736.9 512.3l-.3-.3.3-.3L948.5 292v440z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M671.9 173.5H498.6c-18 0-32.6 14.6-32.6 32.6 0 16.8 12.7 30.6 29 32.4 1.2.1 2.4.2 3.6.2 1.2 0 2.4-.1 3.6-.2H672v267.1c1.4-14.1 7.3-27.8 17.9-38.7L737 418V238.5c-.1-35.9-29.2-65-65.1-65zM307.7 173.5H75.5c-35.9 0-65 29.1-65 65v547c0 35.9 29.1 65 65 65h596.4c35.9 0 65-29.1 65-65V606l-47.1-48.9a65.162 65.162 0 01-17.9-38.7v267.1H75.5v-547H311.3c16.3-1.8 29-15.6 29-32.4 0-18-14.6-32.6-32.6-32.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#35A4DD",
    d: "M403.1 173.5c-18 0-32.6 14.6-32.6 32.6 0 16.8 12.7 30.6 29 32.4 1.2.1 2.4.2 3.6.2 1.2 0 2.4-.1 3.6-.2 16.3-1.8 29-15.6 29-32.4 0-18-14.6-32.6-32.6-32.6z"
  })));
}

export default SvgVideo;